import { useRoutes } from "@hooks/useRoutes";
import {
  type ComponentProps,
  type FromSanityGraphQL,
  type ResolvedLink,
} from "@ts/components";
import { type SectionCollectionButtonSlider } from "@ts/sanity";
import React, { FC } from "react";

type CollectionButtonSliderInputProps = ComponentProps &
  FromSanityGraphQL<SectionCollectionButtonSlider>;

type CollectionButtonSliderOutputProps = Omit<
  CollectionButtonSliderInputProps,
  "titleLink"
> & {
  alignment?: string;
  isActiveCollection: (url: string, title?: string) => void;
  sectionLinks?: ResolvedLink[];
  titleLink?: ResolvedLink;
};

export const withCollectionButtonSlider =
  (Component: FC<CollectionButtonSliderOutputProps>) =>
  ({
    name = "CollectionButtonSlider",
    location,
    sections,
    ...props
  }: CollectionButtonSliderInputProps) => {
    const { linkResolver } = useRoutes();
    const titleLink = linkResolver(props?.titleLink?.[0]);
    const sectionLinks = sections?.map((section: any) => ({
      ...section,
      link: linkResolver(section.customContentLink[0]),
    }));

    const isActiveCollection = (url: string, title?: string) => {
      if (!location?.href || !url) {
        return false;
      }
      return location.href.includes(url) || location.href.includes(title);
    };

    Component.displayName = name;

    if (!sectionLinks?.length) {
      return null;
    }

    return (
      <Component
        {...props}
        alignment={sections?.[0]?.alignment}
        titleLink={titleLink}
        sectionLinks={sectionLinks}
        isActiveCollection={isActiveCollection}
      />
    );
  };
